// TODO move it to globals / constants ?
const AVAILABLE_TIMES = [];
for (let i = 0; i < 23; ++i) {
    const twoDigitHour = String(i).padStart(2, '0');
    AVAILABLE_TIMES.push(`${twoDigitHour}:00`);
    AVAILABLE_TIMES.push(`${twoDigitHour}:30`);
}
export default AVAILABLE_TIMES;
